
window.pdfjsLib = require('pdfjs-dist/build/pdf')
window.pdfjsViewer = require('pdfjs-dist/web/pdf_viewer')
pdfjsLib.GlobalWorkerOptions.workerSrc = '/static/js/pdf.worker.js'

const USE_ONLY_CSS_ZOOM = false
const TEXT_LAYER_MODE = 0
const MAX_IMAGE_SIZE = -1
const CMAP_URL = '/static/cmaps/'
const CMAP_PACKED = true;
const DEFAULT_SCALE_DELTA = 1.1;
const MIN_SCALE = 0.25;
const MAX_SCALE = 10.0;
const DEFAULT_SCALE_VALUE = "auto";

const PDFViewerApplication = {
    pdfLoadingTask: null,
    pdfDocument: null,
    pdfViewer: null,
    pdfHistory: null,
    pdfLinkService: null,
    eventBus: null,

    /**
     * Opens PDF document specified by URL.
     * @returns {Promise} - Returns the promise, which is resolved when document
     *                      is opened.
     */
    open(params) {
        if (this.pdfLoadingTask) {
            // We need to destroy already opened document
            return this.close().then(
                function () {
                    // ... and repeat the open() call.
                    return this.open(params);
                }.bind(this)
            );
        }

        const url = params.url;
        const self = this;

        // Loading document.
        const loadingTask = pdfjsLib.getDocument({
            url,
            maxImageSize: MAX_IMAGE_SIZE,
            cMapUrl: CMAP_URL,
            cMapPacked: CMAP_PACKED,
        });
        this.pdfLoadingTask = loadingTask;

        //loadingTask.onProgress = function (progressData) {
        //    self.progress(progressData.loaded / progressData.total);
       // };

        return loadingTask.promise.then(
            function (pdfDocument) {
                self.pdfDocument = pdfDocument;
                self.pdfViewer.setDocument(pdfDocument);
                self.pdfLinkService.setDocument(pdfDocument);
                self.pdfHistory.initialize({ fingerprint: pdfDocument.fingerprint });

                //self.loadingBar.hide();

            }
        );
    },
    close() {
        if (!this.pdfLoadingTask) {
            return Promise.resolve();
        }

        const promise = this.pdfLoadingTask.destroy();
        this.pdfLoadingTask = null;

        if (this.pdfDocument) {
            this.pdfDocument = null;

            this.pdfViewer.setDocument(null);
            this.pdfLinkService.setDocument(null, null);

            if (this.pdfHistory) {
                this.pdfHistory.reset();
            }
        }

        return promise;
    },

    //get loadingBar() {
    //    const bar = new pdfjsViewer.ProgressBar("#loadingBar", {});
    //
    //    return pdfjsLib.shadow(this, "loadingBar", bar);
    //},
    //progress: function pdfViewProgress(level) {
    //    const percent = Math.round(level * 100);
    //    if (percent > this.loadingBar.percent || isNaN(percent)) {
    //        this.loadingBar.percent = percent;
    //    }
    //},

    get pagesCount() {
        return this.pdfDocument.numPages;
    },

    get page() {
        return this.pdfViewer.currentPageNumber;
    },

    set page(val) {
        this.pdfViewer.currentPageNumber = val;
    },

    zoomIn: function pdfViewZoomIn(ticks) {
        let newScale = this.pdfViewer.currentScale;
        do {
            newScale = (newScale * DEFAULT_SCALE_DELTA).toFixed(2);
            newScale = Math.ceil(newScale * 10) / 10;
            newScale = Math.min(MAX_SCALE, newScale);
        } while (--ticks && newScale < MAX_SCALE);
        this.pdfViewer.currentScaleValue = newScale;
    },

    zoomOut: function pdfViewZoomOut(ticks) {
        let newScale = this.pdfViewer.currentScale;
        do {
            newScale = (newScale / DEFAULT_SCALE_DELTA).toFixed(2);
            newScale = Math.floor(newScale * 10) / 10;
            newScale = Math.max(MIN_SCALE, newScale);
        } while (--ticks && newScale > MIN_SCALE);
        this.pdfViewer.currentScaleValue = newScale;
    },

    initUI: function pdfViewInitUI() {
        const eventBus = new pdfjsViewer.EventBus();
        this.eventBus = eventBus;

        const linkService = new pdfjsViewer.PDFLinkService({
            eventBus,
        });
        this.pdfLinkService = linkService;

        this.l10n = pdfjsViewer.NullL10n;

        const container = document.getElementById("viewerContainer");
        const pdfViewer = new pdfjsViewer.PDFViewer({
            container,
            eventBus,
            linkService,
            l10n: this.l10n,
            useOnlyCssZoom: USE_ONLY_CSS_ZOOM,
            textLayerMode: TEXT_LAYER_MODE,
            maxCanvasPixels: -1,
            //renderer: 'svg'
        });
        this.pdfViewer = pdfViewer;
        linkService.setViewer(pdfViewer);

        this.pdfHistory = new pdfjsViewer.PDFHistory({
            eventBus,
            linkService,
        });
        linkService.setHistory(this.pdfHistory);

        document.getElementById("previous").addEventListener("click", function () {
            PDFViewerApplication.page--;
        });

        document.getElementById("next").addEventListener("click", function () {
            PDFViewerApplication.page++;
        });

        document.getElementById("zoomIn").addEventListener("click", function () {
            PDFViewerApplication.zoomIn();
        });

        document.getElementById("zoomOut").addEventListener("click", function () {
            PDFViewerApplication.zoomOut();
        });

        document
            .getElementById("pageNumber")
            .addEventListener("click", function () {
                this.select();
            });

        document
            .getElementById("pageNumber")
            .addEventListener("change", function () {
                PDFViewerApplication.page = this.value | 0;
                if (this.value !== PDFViewerApplication.page.toString()) {
                    this.value = PDFViewerApplication.page;
                }
            });

        eventBus.on("pagesinit", function () {
            pdfViewer.currentScaleValue = DEFAULT_SCALE_VALUE;
            const numPages = PDFViewerApplication.pagesCount;
            document.getElementById("pageNumber").value = 1 + '/' + numPages;
        });

        eventBus.on(
            "pagechanging",
            function (evt) {
                const page = evt.pageNumber;
                const numPages = PDFViewerApplication.pagesCount;

                document.getElementById("pageNumber").value = page + '/' + numPages;
                document.getElementById("previous").disabled = page <= 1;
                document.getElementById("next").disabled = page >= numPages;
            },
            true
        );
    },
};

export default function pdfViewerInit() {
    let loaded = false;
    document.addEventListener(
        "DOMContentLoaded",
        function () {
            PDFViewerApplication.initUI();
        },
        true
    );

// The offsetParent is not set until the PDF.js iframe or object is visible;
// waiting for first animation.
    const animationStarted = new Promise(function (resolve) {
        window.requestAnimationFrame(resolve);
    });
    //if(window.innerWidth > 991) {
        animationStarted.then(function () {
            PDFViewerApplication.open({
                url: DEFAULT_URL,
            });
            loaded = true
        });
   // }

    window.addEventListener('content-element-show', function (event) {
        if(event.detail === 'document-element' && !loaded) {
            animationStarted.then(function () {
                PDFViewerApplication.open({
                    url: DEFAULT_URL,
                });
                loaded = true
            });
        }
    });
}
